/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
  ViewChild,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DatepicherComponent } from './datepicher/datepicher.component';
import { RoutingService } from '../../../service/routing.service';
import { Location } from '@angular/common';
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { AuthService } from 'src/app/service/auth.service';
import { UserStateService } from 'src/app/shared/services/user-state.service';
import { FilterApiService } from 'src/app/shared/services/customer-api/filter-api.service';
import { YukkApi } from 'src/app/service/yukkapi.service';
import { ConfigService } from 'src/app/service/config.service';
import { MatLegacySelectionList as MatSelectionList } from '@angular/material/legacy-list';
import { HelpComponent } from '../../help/help.component';
import * as moment from 'moment';
import { FilterListService } from './service/filter-list.service';
import { TIMEFRAME_PERIOD_MAP, PRESET_NAMES } from './menu-filters-constants';
import { DateUtils } from 'src/app/shared/utils/date.utils';
import { INTERNAL_COCKPIT_SETTINGS } from 'src/app/shared/utils/cockpit-constants';

/**
 * main menu filter of the application
 */
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-menu-filters',
  templateUrl: './menu-filters.component.html',
  styleUrls: ['./menu-filters.component.scss'],
})
export class MenuFiltersComponent implements AfterViewInit {
  @ViewChild('presetsSelectionList', { static: true })
  private presetsSelectionList: MatSelectionList;

  /**
   * check if filters are activated (non default)
   */
  isFilterActive = false;

  /**
   * fullscreen mode
   */
  fullscreen: boolean;

  /**
   * sort by
   */
  sort: any;

  /**
   * time
   */
  time: any;

  /**
   * array of the time
   */
  timenumber: any = ['0', '1', '2', '7', '30', '90', '180', '365'];

  /**
   * time array string
   */
  timestring: any = [
    'custom',
    'day',
    '24 hours',
    'week',
    'month',
    'quarter',
    '6 months',
    'year',
  ];

  /**
   * time name to display
   */
  timename: string;

  /**
   * feed selected
   */
  feed: any;

  /**
   *
   */
  itheme: string;

  /**
   *
   */
  params: any;

  /**
   *
   */
  layout = 'main';

  /**
   *
   */
  intheme = true;

  /**
   * possible labels and values of language filters
   */
  filterLang = [];
  menuButtonLang = [];

  /**
   * possible labels and values of timeframe filters
   */
  filterTimeframe = [
    {
      label: 'Today',
      value: '1',
    },
    {
      label: '24 hours',
      value: '2',
    },
    {
      label: 'Week',
      value: '7',
    },
    {
      label: 'Month',
      value: '30',
    },
    {
      label: 'Quarter',
      value: '90',
    },
    {
      label: '6 months',
      value: '180',
    },
    {
      label: 'Year',
      value: '365',
    },
    {
      label: 'Custom',
      value: '0',
    },
  ];
  /**
   * form control for timeframe filters
   */
  menuFilterTimeframe: UntypedFormControl;

  /**
   * possible labels and values of sentiment filters
   */
  filterSentiment = [
    {
      label: 'Positive',
      value: 'pos',
    },
    {
      label: 'Neutral',
      value: 'neu',
    },
    {
      label: 'Negative',
      value: 'neg',
    },
  ];
  /**
   * form control for sentiment filters
   */
  menuFilterSentiment: UntypedFormControl;

  /**
   * form control for language filters
   */
  menuFilterLang: UntypedFormControl;

  /**
   *
   */
  project: string;

  /**
   *
   */
  i18n = 'English';

  /**
   * period
   */
  period: string;

  /**
   *
   */
  filterNews = [
    {
      // label: 'Pro (Full Text)',
      label: 'PRO',
      value: 'professional',
      icon: 'star',
      active: true,
    },
    {
      // label: 'Print (Full Text)',
      label: 'PRINT',
      value: 'print',
      icon: 'list_alt',
      active: true,
    },
    {
      // label: 'Web (Finance)',
      label: 'WEB',
      value: 'online',
      icon: 'dvr',
      active: true,
    },
    {
      // label: 'Web (Global)',
      label: 'RSS',
      value: 'non_professional',
      icon: 'rss_feed',
      active: true,
    },
  ];
  menuButtonNews = [];

  /**
   * form control of the feed
   */
  menuFilterNews: UntypedFormControl;

  /**
   * document categories disabled by default
   */
  // defaultDisabledCategories = ['gent', 'gedu', 'ciprof', 'glife', 'cmarkr', 'gpersf', 'gsci', 'gspo', 'gwea'];
  defaultDisabledCategories = [];

  /**
   * filters presets object containing all the data
   */
  presets: any;

  /**
   * default filters preset
   */
  presetDefault = {
    id: 'defaultId',
    name: 'Default',
    feed: 'non_professional,online,print,professional',
    time: '7',
    filter: 'pos,neu,neg',
    lang: 'en,de',
    ranks: null,
    categories: 'glife',
    continents: null,
    countries: null,
    panels: null,
    factuality: null,
    temporality: null,
    event_ids: null,
  };

  /**
   * default filters preset including environmental (E) events
   */
  presetEventsE = {
    id: 'eventsE',
    name: 'E events',
    feed: 'non_professional,online,print,professional',
    time: '7',
    filter: null,
    lang: 'en,de',
    ranks: null,
    categories: 'glife',
    continents: null,
    countries: null,
    panels: null,
    factuality: null,
    temporality: null,
    event_ids:
      'E33_A,E33_B,E33_E,E33_F,E33_J,E33_K,E33_H,E33_I,E49_A,E49_B,E33_D,E34_A,E34_B,E52_B,E52_A,E34_C,E34_D,E33_L',
  };

  /**
   * default filters preset including social (S) events
   */
  presetEventsS = {
    id: 'eventsS',
    name: 'S events',
    feed: 'non_professional,online,print,professional',
    time: '7',
    filter: null,
    lang: 'en,de',
    ranks: null,
    categories: 'glife',
    continents: null,
    countries: null,
    panels: null,
    factuality: null,
    temporality: null,
    event_ids:
      'E48_A,E48_D,E48_E,E48_F,E48_G,E13_B,E13_A,E48_B,E48_C,E51_A,E51_D,E51_B,E3_A,E2_B,E15_A,E2_A,E32_C,E17_B,E17_C,E17_A,E17_D',
  };

  /**
   * default filters preset including governance (G) events
   */
  presetEventsG = {
    id: 'eventsG',
    name: 'G events',
    feed: 'non_professional,online,print,professional',
    time: '7',
    filter: null,
    lang: 'en,de',
    ranks: null,
    categories: 'glife',
    continents: null,
    countries: null,
    panels: null,
    factuality: null,
    temporality: null,
    event_ids:
      'E47_A,E20_A,E22_B,E22_C,E50_B,E50_A,E16_A,E23_A,E33_G,E33_C,E25_E,E21_A,E21_B,E42_C,E45_A,E45_C,E18_B,E18_A,E18_F,E18_G,E6_D,E6_C,E6_B,E6_E,E6_A,E19_A,E19_B',
  };

  /**
   * custom default preset
   */
  presetCustomDefault = {
    id: 'defaultId',
    name: 'Default',
    feed: 'non_professional,online,print,professional',
    time: '7',
    filter: 'pos,neu,neg',
    lang: 'en,de',
    ranks: null,
    categories: 'glife',
    continents: null,
    countries: null,
    panels: null,
    factuality: null,
    temporality: null,
    event_ids: null,
  };

  /**
   * id of the custom default filter
   */
  idCustomDefault: any;

  /**
   * name of the custom default filter
   */
  nameCustomDefault: any;

  /**
   * filters presets array for display
   */
  filterPresets = [];

  /**
   * form control of filters presets
   */
  menuFilterPresets: UntypedFormControl;

  /**
   * all events from URL parameter event_ids
   */
  urlEvents: any;

  /**
   * events object containing info for filtering purposes
   */
  events: any;

  /**
   * events filter
   */
  filterEvents = [];

  /**
   * form control of the events filter
   */
  menuFilterEvents: UntypedFormControl;

  /**
   * sub_events object containing info for filtering purposes
   */
  subEvents: any;

  /**
   * sub_events filter
   */
  filterSubEvents = {};

  /**
   * all subevents
   */
  allSubEvents = [];

  /**
   * document categories object containing info for filtering purposes
   */
  categories: any;

  /**
   * document categories filter
   */
  filterCategories = [];

  /**
   * form control of the document categories filter
   */
  menuFilterCategories: UntypedFormControl;

  /**
   * source panels object containing info for filtering purposes
   */
  panels: any;

  /**
   * source panels filter
   */
  filterPanels = [];

  /**
   * form control of the source panels filter
   */
  menuFilterPanels: UntypedFormControl;

  /**
   * geography filters group object
   */
  filterGeography = {
    continents: [],
    countries: [],
  };

  /**
   * form control of the geography filters
   */
  menuFilterGeography: UntypedFormControl;

  /**
   * geography group autocompletion form, group and options observable
   */
  geographyForm: UntypedFormGroup;
  geographyGroups = [];
  geographyGroupOptions: Observable<any>;

  /**
   * temporality and factuality filters group object
   */
  filterFactTemp = {
    factuality: [
      {
        value: 'fact',
        label: 'Factual',
        selected: false,
      },
      {
        value: 'probable',
        label: 'Probable',
        selected: false,
      },
      {
        value: 'possible',
        label: 'Possible',
        selected: false,
      },
    ],
    temporality: [
      {
        value: 'past',
        label: 'Past',
        selected: false,
      },
      {
        value: 'present',
        label: 'Present',
        selected: false,
      },
      {
        value: 'future',
        label: 'Future',
        selected: false,
      },
    ],
  };

  /**
   * form control of the factuality/temporality filters
   */
  menuFilterFactTemp: UntypedFormControl;

  /**
   * source ranks object containing info for filtering purposes
   */
  ranks: any;

  /**
   * source ranks filter
   */
  filterRanks = [];

  /**
   * form control of the source ranks filter
   */
  menuFilterRanks: UntypedFormControl;

  /**
   * special tag filter
   */
  tagFilter = null;

  /**
   * special participant filter
   */
  participantFilter = null;

  /**
   * omit resetting filters on menu close
   */
  omitReset = false;

  /**
   * query parameters subscribe and initialize the formcontrols
   */
  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private yukkApi: YukkApi,
    public dialog: MatDialog,
    public routing: RoutingService,
    public location: Location,
    public snackBar: MatSnackBar,
    public auth: AuthService,
    public userState: UserStateService,
    private filterApi: FilterApiService,
    public config: ConfigService,
    private cd: ChangeDetectorRef,
    private filterListService: FilterListService,
  ) {
    this.project = this.config.appConfig.routing.project;

    const currentDay = new Date();
    const startDay = new Date(this.config.appConfig.setup.startDate);
    const maxTimeframe = moment(currentDay).diff(moment(startDay), 'days');
    this.filterTimeframe = this.filterTimeframe.filter((el) => {
      return (
        Number(el.value) <= Number(INTERNAL_COCKPIT_SETTINGS.maxTimeframe) &&
        Number(el.value) <= Number(maxTimeframe)
      );
    });

    this.route.queryParams.subscribe((params) => {
      if (params.tag) {
        this.tagFilter = params.tag;
      } else {
        this.tagFilter = null;
      }
      if (params.participant) {
        this.participantFilter = params.participant;
      } else {
        this.participantFilter = null;
      }

      this.menuFilterPresets = new UntypedFormControl();

      if (this.filterPresets.length === 0) {
        this.filterApi.getFilter().subscribe((result) => {
          this.presets = result;
          this.filterPresets = [];

          const defaultPreset = {
            label: 'Default',
            value: 'Default',
            visible: false,
            presetCopy: JSON.parse(JSON.stringify(this.presetDefault)),
          };

          this.filterPresets.push(defaultPreset);

          if (
            this.auth.scorelabSettings.defaultScore === 'esg' ||
            this.auth.scorelabSettings.defaultScore === 'esg_risk'
          ) {
            const eventsEpreset = {
              label: 'E events',
              value: 'E events',
              visible: false,
              presetCopy: JSON.parse(JSON.stringify(this.presetEventsE)),
            };
            const eventsSpreset = {
              label: 'S events',
              value: 'S events',
              visible: false,
              presetCopy: JSON.parse(JSON.stringify(this.presetEventsS)),
            };
            const eventsGpreset = {
              label: 'G events',
              value: 'G events',
              visible: false,
              presetCopy: JSON.parse(JSON.stringify(this.presetEventsG)),
            };
            this.filterPresets.push(eventsEpreset);
            this.filterPresets.push(eventsSpreset);
            this.filterPresets.push(eventsGpreset);
          }

          result.forEach((item) => {
            if (item.name === '_default_') {
              Object.assign(this.presetCustomDefault, item);
              this.idCustomDefault = item.id;
              if (item.defaultFilter) {
                this.nameCustomDefault = item.defaultFilter;
              }
            } else {
              this.filterPresets.push({
                label: item.name,
                value: item.name,
                visible: false,
                presetCopy: item,
              });
            }
          });

          // Move custom default filter to the very top of the list
          if (this.nameCustomDefault) {
            const customDefaultIndex = this.filterPresets.findIndex(
              (preset) => preset.label === this.nameCustomDefault,
            );
            if (customDefaultIndex > 0) {
              const customDefaultPreset = this.filterPresets.splice(
                customDefaultIndex,
                1,
              )[0];
              this.filterPresets.unshift(customDefaultPreset);
            }
          }

          if (this.hasFilterChanged(params, this.presetCustomDefault)) {
            this.isFilterActive = true;
            if (this.userState.filter && this.userState.filter === 'Default') {
              this.userState.filter = 'Custom';
            }

            let presetId;
            // @ts-expect-error Description of why the error is expected
            this.presetsSelectionList.options._results.forEach(
              (item, index) => {
                if (item._value === this.userState.filter) {
                  presetId = index;
                  setTimeout(() => {
                    if (
                      this.presetsSelectionList &&
                      // @ts-expect-error Description of why the error is expected
                      this.presetsSelectionList.options._results
                    ) {
                      this.presetsSelectionList.deselectAll();
                      // @ts-expect-error Description of why the error is expected
                      this.presetsSelectionList.options._results[
                        presetId
                      ]._setSelected(true);
                    }
                  }, 200);
                }
              },
            );
          } else {
            this.isFilterActive = false;
            // Only set default if no filter is currently selected
            if (!this.userState.filter) {
              this.userState.filter = this.nameCustomDefault || 'Default';
            }

            setTimeout(() => {
              if (
                this.presetsSelectionList &&
                this.presetsSelectionList.options
              ) {
                // Find and select the current filter
                // @ts-expect-error Accessing private _results property
                const results = this.presetsSelectionList.options._results;
                const currentFilterOption = results.find(
                  (option: any) => option._value === this.userState.filter,
                );

                if (currentFilterOption) {
                  this.presetsSelectionList.deselectAll();
                  currentFilterOption._setSelected(true);
                } else {
                  // Fallback: select custom default or first option
                  this.presetsSelectionList.deselectAll();
                  let presetToSelect = null;
                  if (this.nameCustomDefault) {
                    presetToSelect = results.find(
                      (option: any) => option._value === this.nameCustomDefault,
                    );
                  }
                  if (
                    !presetToSelect &&
                    this.presetsSelectionList.options.first
                  ) {
                    presetToSelect = this.presetsSelectionList.options.first;
                  }
                  if (presetToSelect) {
                    presetToSelect._setSelected(true);
                  }
                }
              }
            }, 200);
          }
        });
      } else {
        // Check if E events already exists in the array
        const hasEEvents = this.filterPresets.some(
          (preset) => preset.value === 'E events',
        );

        if (
          (this.auth.scorelabSettings.defaultScore === 'esg' ||
            this.auth.scorelabSettings.defaultScore === 'esg_risk') &&
          this.filterPresets &&
          this.filterPresets.length > 0 &&
          !hasEEvents
        ) {
          const eventsEpreset = {
            label: 'E events',
            value: 'E events',
            visible: false,
            presetCopy: JSON.parse(JSON.stringify(this.presetEventsE)),
          };
          const eventsSpreset = {
            label: 'S events',
            value: 'S events',
            visible: false,
            presetCopy: JSON.parse(JSON.stringify(this.presetEventsS)),
          };
          const eventsGpreset = {
            label: 'G events',
            value: 'G events',
            visible: false,
            presetCopy: JSON.parse(JSON.stringify(this.presetEventsG)),
          };
          // Insert E, S, G events after the Default preset
          const insertIndex = this.nameCustomDefault ? 2 : 1;
          this.filterPresets.splice(
            insertIndex,
            0,
            eventsEpreset,
            eventsSpreset,
            eventsGpreset,
          );
        }

        if (this.hasFilterChanged(params, this.presetCustomDefault)) {
          this.isFilterActive = true;
          if (this.userState.filter && this.userState.filter === 'Default') {
            this.userState.filter = 'Custom';
          }
          let presetId;
          // @ts-expect-error Description of why the error is expected
          this.presetsSelectionList.options._results.forEach((item, index) => {
            if (item._value === this.userState.filter) {
              presetId = index;
              setTimeout(() => {
                if (
                  this.presetsSelectionList &&
                  // @ts-expect-error Description of why the error is expected
                  this.presetsSelectionList.options._results
                ) {
                  this.presetsSelectionList.deselectAll();
                  // @ts-expect-error Description of why the error is expected
                  this.presetsSelectionList.options._results[
                    presetId
                  ]._setSelected(true);
                }
              }, 200);
            }
          });
        } else {
          this.isFilterActive = false;
          // Only set default if no filter is currently selected
          if (!this.userState.filter) {
            this.userState.filter = this.nameCustomDefault || 'Default';
          }
          setTimeout(() => {
            if (
              this.presetsSelectionList &&
              this.presetsSelectionList.options
            ) {
              // Find and select the current filter
              // @ts-expect-error Accessing private _results property
              const results = this.presetsSelectionList.options._results;
              const currentFilterOption = results.find(
                (option: any) => option._value === this.userState.filter,
              );

              if (currentFilterOption) {
                this.presetsSelectionList.deselectAll();
                currentFilterOption._setSelected(true);
              } else {
                // Fallback: select custom default or first option
                this.presetsSelectionList.deselectAll();
                let presetToSelect = null;
                if (this.nameCustomDefault) {
                  presetToSelect = results.find(
                    (option: any) => option._value === this.nameCustomDefault,
                  );
                }
                if (
                  !presetToSelect &&
                  this.presetsSelectionList.options.first
                ) {
                  presetToSelect = this.presetsSelectionList.options.first;
                }
                if (presetToSelect) {
                  presetToSelect._setSelected(true);
                }
              }
            }
          }, 200);
        }
      }

      if (params.eventid && params.eventype === 'sub_event') {
        this.urlEvents = params.eventid.split(',');
        this.menuFilterEvents = new UntypedFormControl(
          params.eventid.split(','),
        );
      } else if (params.event_ids) {
        this.urlEvents = params.event_ids.split(',');
        this.menuFilterEvents = new UntypedFormControl(
          params.event_ids.split(','),
        );
      } else {
        this.urlEvents = [];
        this.menuFilterEvents = new UntypedFormControl();
      }
      this.events = [];
      this.subEvents = [];

      if (params.categories) {
        this.menuFilterCategories = new UntypedFormControl(
          this.filterCategories
            .filter(
              (option) => !params.categories.split(',').includes(option.value),
            )
            .map((option) => option.value),
        );
      } else {
        this.menuFilterCategories = new UntypedFormControl(
          this.filterCategories.map((option) => option.value),
        );
      }
      if (params.ranks) {
        this.menuFilterRanks = new UntypedFormControl(params.ranks.split(','));
      } else {
        this.menuFilterRanks = new UntypedFormControl();
      }
      if (params.panels) {
        this.menuFilterPanels = new UntypedFormControl(
          params.panels.split(','),
        );
      } else {
        this.menuFilterPanels = new UntypedFormControl();
      }
      let geography = [];
      if (params.continents) {
        const continentsArray = params.continents
          .split(',')
          .map((continent) => 'continent ' + continent);
        geography = geography.concat(continentsArray);
      }
      if (params.countries) {
        const countriesArray = params.countries
          .split(',')
          .map((country) => 'country ' + country);
        geography = geography.concat(countriesArray);
      }
      this.menuFilterGeography = new UntypedFormControl(geography);

      this.geographyForm = this.formBuilder.group({
        geographyGroup: '',
      });

      this.geographyGroupOptions = this.geographyForm
        .get('geographyGroup')!
        .valueChanges.pipe(
          startWith(''),
          map((value) => this.groupMatches(value)),
        );

      let tempAndFact = [];
      if (params.factuality) {
        const factualityArray = params.factuality.split(',');
        tempAndFact = tempAndFact.concat(factualityArray);
      }
      if (params.temporality) {
        const temporalityArray = params.temporality.split(',');
        tempAndFact = tempAndFact.concat(temporalityArray);
      }
      this.menuFilterFactTemp = new UntypedFormControl(tempAndFact);

      if (
        this.filterLang.length === 0 ||
        this.filterCategories.length === 0 ||
        this.filterRanks.length === 0 ||
        this.filterGeography.continents.length === 0 ||
        this.filterGeography.countries.length === 0 ||
        this.filterPanels.length === 0 ||
        this.filterEvents.length === 0
      ) {
        this.filterListService.getFilterListItem().subscribe((result) => {
          const languages = result.languages;
          const documentCategories = result.documentCategories;
          const sourceRanks = result.sourceRanks;
          const sourceContinents = result.sourceContinents;
          const sourceCountries = result.sourceCountries;
          const sourcePanels = result.sourcePanels;

          const events = result.events;
          if (events.length === 1) {
            this.userState.eventsList = result.eventList;
            this.filterEvents = result.filterEvents;
            this.filterSubEvents = result.filterSubEvents;
            this.allSubEvents = result.allSubEvents;

            this.filterEvents.forEach((element, index) => {
              if (
                this.urlEvents.length !== 0 &&
                this.urlEvents.includes(element.value)
              ) {
                this.filterEvents[index].selected = true;
                this.events.push(element.value);
              } else {
                this.filterEvents[index].selected = false;
              }
              this.filterSubEvents[element.value].forEach(
                (element2, index2) => {
                  if (
                    this.urlEvents.length !== 0 &&
                    this.urlEvents.includes(element2.value)
                  ) {
                    this.filterSubEvents[element.value][index2].selected = true;
                    this.subEvents.push(element2.value);
                  } else {
                    this.filterSubEvents[element.value][index2].selected =
                      false;
                  }
                },
              );
            });
          }
          if (documentCategories.length === 1) {
            this.filterCategories = documentCategories[0].values
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((element) => {
                return {
                  value: element.value,
                  label: element.name,
                  selected: !this.defaultDisabledCategories.includes(
                    element.value,
                  ),
                };
              });
            if (params.categories) {
              this.menuFilterCategories = new UntypedFormControl(
                this.filterCategories
                  .filter(
                    (option) =>
                      !params.categories.split(',').includes(option.value),
                  )
                  .map((option) => option.value),
              );
            } else {
              this.menuFilterCategories = new UntypedFormControl(
                this.filterCategories.map((option) => option.value),
              );
            }
            this.filterCategories.forEach((element, index) => {
              if (this.menuFilterCategories.value !== null) {
                this.filterCategories[index].selected =
                  this.menuFilterCategories.value.includes(element.value);
              } else {
                this.filterCategories[index].selected =
                  !this.defaultDisabledCategories.includes(element.value);
              }
            });
          } else {
            this.filterCategories = [];
          }
          if (languages.length === 1) {
            this.filterLang = languages[0].values.map((element) => {
              return {
                value: element.value,
                label: element.name,
              };
            });
            if (!this.auth.featureFlags.betaLanguages) {
              this.filterLang = this.filterLang.filter((el) =>
                ['en', 'de'].includes(el.value),
              );
            }
            if (params.lang) {
              this.menuFilterLang = new UntypedFormControl(
                params.lang.split(','),
              );
              this.menuButtonLang = this.filterLang.filter(
                (option) => params.lang.split(',').indexOf(option.value) !== -1,
              );
            } else {
              this.menuFilterLang = new UntypedFormControl(
                this.presetDefault.lang.split(','),
              );
              this.menuButtonLang = this.filterLang.filter(
                (option) =>
                  this.menuFilterLang.value.indexOf(option.value) !== -1,
              );
            }
          } else {
            this.filterLang = [];
          }
          if (sourceRanks.length === 1) {
            this.filterRanks = sourceRanks[0].values.map((element) => {
              return {
                value: element.value.toString(),
                label: 'Rank ' + element.name,
              };
            });
          } else {
            this.filterRanks = [];
          }
          if (sourceContinents.length === 1) {
            this.filterGeography.continents = sourceContinents[0].values.map(
              (element) => {
                return {
                  value: 'continent ' + element.value,
                  label: element.name,
                  selected: false,
                };
              },
            );
            this.filterGeography.continents.forEach((element, index) => {
              if (this.menuFilterGeography.value !== null) {
                this.filterGeography.continents[index].selected =
                  this.menuFilterGeography.value.includes(element.value);
              } else {
                this.filterGeography.continents[index].selected = false;
              }
            });
          } else {
            this.filterGeography.continents = [];
          }
          if (sourceCountries.length === 1) {
            this.filterGeography.countries = sourceCountries[0].values.map(
              (element) => {
                return {
                  value: 'country ' + element.value,
                  label: element.name,
                  selected: false,
                };
              },
            );
            this.filterGeography.countries.forEach((element, index) => {
              if (this.menuFilterGeography.value !== null) {
                this.filterGeography.countries[index].selected =
                  this.menuFilterGeography.value.includes(element.value);
              } else {
                this.filterGeography.countries[index].selected = false;
              }
            });
          } else {
            this.filterGeography.countries = [];
          }
          if (sourcePanels.length === 1) {
            this.filterPanels = sourcePanels[0].values.map((element) => {
              return {
                value: element.value.toString(),
                label: element.name,
              };
            });
          } else {
            this.filterPanels = [];
          }

          this.geographyGroups = [
            {
              type: 'Continents',
              names: this.filterGeography.continents.map(
                (continent) => continent.label,
              ),
            },
            {
              type: 'Countries',
              names: this.filterGeography.countries.map(
                (country) => country.label,
              ),
            },
          ];
        });
      } else {
        this.filterCategories.forEach((element, index) => {
          if (this.menuFilterCategories.value !== null) {
            this.filterCategories[index].selected =
              this.menuFilterCategories.value.includes(element.value);
          } else {
            this.filterCategories[index].selected =
              !this.defaultDisabledCategories.includes(element.value);
          }
        });
        this.filterGeography.continents.forEach((element, index) => {
          if (this.menuFilterGeography.value !== null) {
            this.filterGeography.continents[index].selected =
              this.menuFilterGeography.value.includes(element.value);
          } else {
            this.filterGeography.continents[index].selected = false;
          }
        });
        this.filterGeography.countries.forEach((element, index) => {
          if (this.menuFilterGeography.value !== null) {
            this.filterGeography.countries[index].selected =
              this.menuFilterGeography.value.includes(element.value);
          } else {
            this.filterGeography.countries[index].selected = false;
          }
        });
        this.filterEvents.forEach((element, index) => {
          if (
            this.urlEvents.length !== 0 &&
            this.urlEvents.includes(element.value)
          ) {
            this.filterEvents[index].selected = true;
            this.events.push(element.value);
          } else {
            this.filterEvents[index].selected = false;
          }
          this.filterSubEvents[element.value].forEach((element2, index2) => {
            if (
              this.urlEvents.length !== 0 &&
              this.urlEvents.includes(element2.value)
            ) {
              this.filterSubEvents[element.value][index2].selected = true;
              this.subEvents.push(element2.value);
            } else {
              this.filterSubEvents[element.value][index2].selected = false;
            }
          });
        });
        this.filterFactTemp.factuality.forEach((element, index) => {
          if (this.menuFilterFactTemp.value !== null) {
            this.filterFactTemp.factuality[index].selected =
              this.menuFilterFactTemp.value.includes(element.value);
          } else {
            this.filterFactTemp.factuality[index].selected = false;
          }
        });
        this.filterFactTemp.temporality.forEach((element, index) => {
          if (this.menuFilterFactTemp.value !== null) {
            this.filterFactTemp.temporality[index].selected =
              this.menuFilterFactTemp.value.includes(element.value);
          } else {
            this.filterFactTemp.temporality[index].selected = false;
          }
        });
      }

      this.period = params.period ? params.period : '7';
      if (params.filter) {
        this.menuFilterSentiment = new UntypedFormControl(
          params.filter.split(','),
        );
      } else {
        this.menuFilterSentiment = new UntypedFormControl(
          this.filterSentiment.map((option) => option.value),
        );
      }
      if (params.lang) {
        this.menuFilterLang = new UntypedFormControl(params.lang.split(','));
        this.menuButtonLang = this.filterLang.filter(
          (option) => params.lang.split(',').indexOf(option.value) !== -1,
        );
      } else {
        this.menuFilterLang = new UntypedFormControl(
          this.presetDefault.lang.split(','),
        );
        this.menuButtonLang = this.filterLang.filter(
          (option) => this.menuFilterLang.value.indexOf(option.value) !== -1,
        );
      }
      if (params.feed) {
        this.menuFilterNews = new UntypedFormControl(params.feed.split(','));
        this.menuButtonNews = this.filterNews.filter(
          (option) => params.feed.split(',').indexOf(option.value) !== -1,
        );
      } else {
        this.menuFilterNews = new UntypedFormControl(
          this.filterNews.map((option) => {
            if (option.active) {
              return option.value;
            }
          }),
        );
        this.menuButtonNews = this.filterNews.filter(
          (option) => this.menuFilterNews.value.indexOf(option.value) !== -1,
        );
      }
      this.itheme = this.routing.theme;
      this.params = params;
      this.fullscreen = params.fullscreen === 'true' ? true : false;
      if (params.feed) {
        this.feed = params.feed;
      } else {
        this.feed = 'all';
      }
      if (params.time) {
        this.time = params.time;
        if (
          params.time === '1' ||
          params.time === '2' ||
          params.time === '7' ||
          params.time === '14' ||
          params.time === '30' ||
          params.time === '90' ||
          params.time === '180' ||
          params.time === '365'
        ) {
          this.menuFilterTimeframe = new UntypedFormControl(
            params.time.split(','),
          );
        } else {
          this.menuFilterTimeframe = new UntypedFormControl(['0']);
        }
      } else {
        this.time = '7';
        this.menuFilterTimeframe = new UntypedFormControl(['7']);
      }
      this.timename = this.timestring[this.timenumber.indexOf(this.time)];
      if (this.timename === 'custom') {
        this.timename = params.time;
      }
    });
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  /**
   * parse the time
   */
  goTime(value) {
    let period = value;
    if (value === 30) {
      period = 7;
    }
    if (value === 90) {
      period = 14;
    }
    if (value === 180) {
      period = 14;
    }
    if (value === 365) {
      period = 14;
    }
    this.router.navigate([], {
      queryParams: {
        time: value,
        period: period,
        tag: null,
        newsday: null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  /**
   * open dialog datepicher
   */
  goCustom() {
    let time = this.time;
    if (this.time === '0') {
      time = this.params.time;
    }
    const dialogRef = this.dialog.open(DatepicherComponent, {
      data: {
        time: time,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (
        result &&
        Object.prototype.hasOwnProperty.call(result, 'time') &&
        Object.prototype.hasOwnProperty.call(result, 'period')
      ) {
        this.time = result.time;
        this.period = result.period;
      } else {
        if (this.params.time) {
          if (this.params.time < 500) {
            this.menuFilterTimeframe = new UntypedFormControl(
              this.params.time.split(','),
            );
          } else {
            this.menuFilterTimeframe = new UntypedFormControl(['0']);
          }
        } else {
          this.menuFilterTimeframe = new UntypedFormControl(['7']);
        }
      }
    });
  }

  /**
   * go fullscreen
   */
  goFullscreen() {
    if (this.fullscreen) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
  }

  /**
   * change the feed type
   */
  goFeed(value) {
    this.router.navigate([], {
      queryParams: {
        feed: value,
        newsday: null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  /**
   * change sort by
   */
  goSortBy(value) {
    this.router.navigate([], {
      queryParams: {
        sort: value,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  /**
   * change the theme
   */
  inTheme(theme) {
    // localStorage.set('theme', theme)
    this.router.navigate([], {
      queryParams: {
        theme: theme,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
    // this.routing.inTheme(theme)
  }

  handleSearch(name, type) {
    const geographyArray = this.menuFilterGeography.value;
    if (type === 'Continents') {
      this.filterGeography.continents.forEach((element, index) => {
        if (element.label === name && element.selected === false) {
          this.filterGeography.continents[index].selected = true;
          geographyArray.push(element.value);
          this.menuFilterGeography.setValue(geographyArray);
        }
      });
    } else if (type === 'Countries') {
      this.filterGeography.countries.forEach((element, index) => {
        if (element.label === name && element.selected === false) {
          this.filterGeography.countries[index].selected = true;
          geographyArray.push(element.value);
          this.menuFilterGeography.setValue(geographyArray);
        }
      });
    }
  }

  /**
   * flag selected items from multi-selection lists
   */
  handleSelection(element) {
    element.selected = !element.selected;

    // Update form controls to keep them in sync with selected state
    // For categories
    if (this.filterCategories && this.filterCategories.includes(element)) {
      const selectedCategories = this.filterCategories
        .filter((cat) => cat.selected)
        .map((cat) => cat.value);
      this.menuFilterCategories.setValue(selectedCategories);
    }

    // For events/subevents
    let isSubevent = false;
    if (this.filterSubEvents) {
      for (const eventKey in this.filterSubEvents) {
        if (this.filterSubEvents[eventKey].includes(element)) {
          isSubevent = true;
          break;
        }
      }
    }

    if (isSubevent) {
      const selectedEvents = [];
      this.filterEvents.forEach((event) => {
        this.filterSubEvents[event.value].forEach((subevent) => {
          if (subevent.selected) {
            selectedEvents.push(subevent.value);
          }
        });
      });
      this.menuFilterEvents.setValue(selectedEvents);
    }

    this.presetsSelectionList.deselectAll();
    this.userState.filter = 'Custom';
  }

  /**
   * select or deselect all events at once
   */
  toggleAllEvents() {
    const events = [];
    this.filterEvents.forEach((event) => {
      this.filterSubEvents[event.value].forEach((subevent) => {
        events.push(subevent.value);
      });
    });
    const shouldSelectAll =
      this.menuFilterEvents.value?.length !== events.length;
    if (shouldSelectAll) {
      this.filterEvents.forEach((event) => {
        this.filterSubEvents[event.value].forEach((subevent) => {
          subevent.selected = true;
        });
      });
      this.menuFilterEvents.setValue(events);
    } else {
      this.filterEvents.forEach((event) => {
        this.filterSubEvents[event.value].forEach((subevent) => {
          subevent.selected = false;
        });
      });
      this.menuFilterEvents.setValue([]);
    }
    if (
      this.menuFilterEvents.value &&
      (this.menuFilterEvents.value.length === events.length ||
        this.menuFilterEvents.value.length === 0)
    ) {
      this.markFilterAsCustom();
    }
  }

  /**
   * select or deselect all categories at once
   */
  toggleAllCategories() {
    this.toggleAllItems(this.filterCategories, this.menuFilterCategories);
  }

  /**
   * tooltip for categories selection checkbox based on current selection status
   */
  categoriesTooltip() {
    if (
      this.menuFilterCategories.value?.length !== this.filterCategories?.length
    ) {
      return 'Select all categories';
    } else {
      return 'Deselect all categories';
    }
  }

  /**
   * get total count of all subevents across all event categories
   */
  getTotalSubeventsCount(): number {
    if (!this.filterSubEvents || !this.filterEvents) {
      return 0;
    }
    let total = 0;
    this.filterEvents.forEach((event) => {
      if (this.filterSubEvents[event.value]) {
        total += this.filterSubEvents[event.value].length;
      }
    });
    return total;
  }

  /**
   * check if any subevents in an event category are selected
   */
  hasSelectedSubevents(eventValue: string): boolean {
    if (!this.filterSubEvents || !this.filterSubEvents[eventValue]) {
      return false;
    }
    return this.filterSubEvents[eventValue].some(
      (subevent) => subevent.selected,
    );
  }

  /**
   * tooltip for events selection checkbox based on current selection status
   */
  eventsToggleTooltip() {
    if (this.menuFilterEvents.value?.length !== this.getTotalSubeventsCount()) {
      return 'Select all events';
    } else {
      return 'Deselect all events';
    }
  }

  /**
   * on user's click remove filter or change to default one
   * @param type
   * @param value
   */
  removeFilter(type, value) {
    if (type === 'tag') {
      this.tagFilter = null;
      this.router.navigate([], {
        queryParams: {
          tag: null,
        },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    } else if (type === 'participant') {
      this.participantFilter = null;
      this.router.navigate([], {
        queryParams: {
          participant: null,
        },
        queryParamsHandling: 'merge',
        replaceUrl: false,
      });
    } else {
      if (type === 'timeframe') {
        this.menuFilterTimeframe = new UntypedFormControl(
          this.presetCustomDefault.time.split(','),
        );
        this.markFilterAsCustom();
      } else if (type === 'sentiment') {
        if (this.menuFilterSentiment.value.length > 1) {
          const sentiment = this.menuFilterSentiment.value.filter(
            (item) => item !== value,
          );
          this.menuFilterSentiment = new UntypedFormControl(sentiment);
        } else {
          this.menuFilterSentiment = new UntypedFormControl(
            this.presetDefault.filter.split(','),
          );
        }
        this.markFilterAsCustom();
      } else if (type === 'language') {
        if (this.menuFilterLang.value.length > 1) {
          const language = this.menuFilterLang.value.filter(
            (item) => item !== value,
          );
          this.menuFilterLang = new UntypedFormControl(language);
        } else {
          this.menuFilterLang = new UntypedFormControl(
            this.presetDefault.lang.split(','),
          );
        }
        this.markFilterAsCustom();
      } else if (type === 'news') {
        if (this.menuFilterNews.value.length > 1) {
          const newsfeed = this.menuFilterNews.value.filter(
            (item) => item !== value,
          );
          this.menuFilterNews = new UntypedFormControl(newsfeed);
        } else {
          this.menuFilterNews = new UntypedFormControl(
            this.presetDefault.feed.split(','),
          );
        }
        this.markFilterAsCustom();
      } else if (type === 'rank') {
        const ranks = this.menuFilterRanks.value.filter(
          (item) => item !== value,
        );
        this.menuFilterRanks = new UntypedFormControl(ranks);
        this.markFilterAsCustom();
      } else if (type === 'panel') {
        const panels = this.menuFilterPanels.value.filter(
          (item) => item !== value,
        );
        this.menuFilterPanels = new UntypedFormControl(panels);
        this.markFilterAsCustom();
      } else if (type === 'category') {
        const categories = this.menuFilterCategories.value.filter(
          (item) => item !== value,
        );
        this.menuFilterCategories = new UntypedFormControl(categories);
        this.markFilterAsCustom();
      } else if (type === 'continent' || type === 'country') {
        const geographies = this.menuFilterGeography.value.filter(
          (item) => item !== value,
        );
        this.menuFilterGeography = new UntypedFormControl(geographies);
        this.markFilterAsCustom();
      } else if (type === 'subevent') {
        const events = this.menuFilterEvents.value.filter(
          (item) => item !== value,
        );
        this.menuFilterEvents = new UntypedFormControl(events);
        this.markFilterAsCustom();
      } else if (type === 'factuality' || type === 'temporality') {
        const facttemp = this.menuFilterFactTemp.value.filter(
          (item) => item !== value,
        );
        this.menuFilterFactTemp = new UntypedFormControl(facttemp);
        this.markFilterAsCustom();
      }
      this.setFilterOptions();
    }
  }

  /**
   * deselect selected preset on filters change
   */
  handleNoSelection() {
    this.presetsSelectionList.deselectAll();
    this.userState.filter = 'Custom';
  }

  /**
   * apply selected preset to all filters
   */
  handlePresetSelection(selectedPreset) {
    this.userState.filter = selectedPreset.label;
    if (selectedPreset.presetCopy.time) {
      this.time = selectedPreset.presetCopy.time;
      if (
        selectedPreset.presetCopy.time === '1' ||
        selectedPreset.presetCopy.time === '2' ||
        selectedPreset.presetCopy.time === '7' ||
        selectedPreset.presetCopy.time === '14' ||
        selectedPreset.presetCopy.time === '30' ||
        selectedPreset.presetCopy.time === '90' ||
        selectedPreset.presetCopy.time === '180' ||
        selectedPreset.presetCopy.time === '365'
      ) {
        this.menuFilterTimeframe = new UntypedFormControl(
          selectedPreset.presetCopy.time.split(','),
        );
      } else {
        this.menuFilterTimeframe = new UntypedFormControl(['0']);
      }
    } else {
      this.time = '7';
      this.menuFilterTimeframe = new UntypedFormControl(['7']);
    }
    this.timename = this.timestring[this.timenumber.indexOf(this.time)];
    if (this.timename === 'custom') {
      this.timename = selectedPreset.presetCopy.time;
    }

    if (selectedPreset.presetCopy.filter) {
      this.menuFilterSentiment = new UntypedFormControl(
        selectedPreset.presetCopy.filter.split(','),
      );
    } else {
      this.menuFilterSentiment = new UntypedFormControl(
        this.filterSentiment.map((option) => option.value),
      );
    }

    if (selectedPreset.presetCopy.lang) {
      this.menuFilterLang = new UntypedFormControl(
        selectedPreset.presetCopy.lang.split(','),
      );
    } else {
      this.menuFilterLang = new UntypedFormControl(
        this.filterLang.map((option) => option.value),
      );
    }

    if (selectedPreset.presetCopy.ranks) {
      this.menuFilterRanks = new UntypedFormControl(
        selectedPreset.presetCopy.ranks.split(','),
      );
    } else {
      this.menuFilterRanks = new UntypedFormControl();
    }

    if (selectedPreset.presetCopy.panels) {
      this.menuFilterPanels = new UntypedFormControl(
        selectedPreset.presetCopy.panels.split(','),
      );
    } else {
      this.menuFilterPanels = new UntypedFormControl();
    }

    if (selectedPreset.presetCopy.categories) {
      this.menuFilterCategories = new UntypedFormControl(
        this.filterCategories
          .filter(
            (option) =>
              !selectedPreset.presetCopy.categories
                .split(',')
                .includes(option.value),
          )
          .map((option) => option.value),
      );
    } else {
      this.menuFilterCategories = new UntypedFormControl(
        this.filterCategories
          .filter(
            (option) => !this.defaultDisabledCategories.includes(option.value),
          )
          .map((option) => option.value),
      );
    }
    this.filterCategories.forEach((element, index) => {
      if (this.menuFilterCategories.value !== null) {
        this.filterCategories[index].selected =
          this.menuFilterCategories.value.includes(element.value);
      } else {
        this.filterCategories[index].selected =
          !this.defaultDisabledCategories.includes(element.value);
      }
    });

    let geography = [];
    if (selectedPreset.presetCopy.continents) {
      const continentsArray = selectedPreset.presetCopy.continents
        .split(',')
        .map((continent) => 'continent ' + continent);
      geography = geography.concat(continentsArray);
    }
    if (selectedPreset.presetCopy.countries) {
      const countriesArray = selectedPreset.presetCopy.countries
        .split(',')
        .map((country) => 'country ' + country);
      geography = geography.concat(countriesArray);
    }
    this.menuFilterGeography = new UntypedFormControl(geography);
    this.filterGeography.continents.forEach((element, index) => {
      if (this.menuFilterGeography.value !== null) {
        this.filterGeography.continents[index].selected =
          this.menuFilterGeography.value.includes(element.value);
      } else {
        this.filterGeography.continents[index].selected = false;
      }
    });
    this.filterGeography.countries.forEach((element, index) => {
      if (this.menuFilterGeography.value !== null) {
        this.filterGeography.countries[index].selected =
          this.menuFilterGeography.value.includes(element.value);
      } else {
        this.filterGeography.countries[index].selected = false;
      }
    });

    let facttemp = [];
    if (selectedPreset.presetCopy.factuality) {
      const factualityArray = selectedPreset.presetCopy.factuality.split(',');
      facttemp = facttemp.concat(factualityArray);
    }
    if (selectedPreset.presetCopy.temporality) {
      const temporalityArray = selectedPreset.presetCopy.temporality.split(',');
      facttemp = facttemp.concat(temporalityArray);
    }
    this.menuFilterFactTemp = new UntypedFormControl(facttemp);
    this.filterFactTemp.factuality.forEach((element, index) => {
      if (this.menuFilterFactTemp.value !== null) {
        this.filterFactTemp.factuality[index].selected =
          this.menuFilterFactTemp.value.includes(element.value);
      } else {
        this.filterFactTemp.factuality[index].selected = false;
      }
    });
    this.filterFactTemp.temporality.forEach((element, index) => {
      if (this.menuFilterFactTemp.value !== null) {
        this.filterFactTemp.temporality[index].selected =
          this.menuFilterFactTemp.value.includes(element.value);
      } else {
        this.filterFactTemp.temporality[index].selected = false;
      }
    });

    if (selectedPreset.presetCopy.event_ids) {
      this.urlEvents = selectedPreset.presetCopy.event_ids.split(',');
      this.menuFilterEvents = new UntypedFormControl(
        selectedPreset.presetCopy.event_ids.split(','),
      );
    } else {
      this.urlEvents = [];
      this.menuFilterEvents = new UntypedFormControl();
    }
    this.events = [];
    this.subEvents = [];
    this.filterEvents.forEach((element, index) => {
      if (
        this.urlEvents.length !== 0 &&
        this.urlEvents.includes(element.value)
      ) {
        this.filterEvents[index].selected = true;
        this.events.push(element.value);
      } else {
        this.filterEvents[index].selected = false;
      }
      this.filterSubEvents[element.value].forEach((element2, index2) => {
        if (
          this.urlEvents.length !== 0 &&
          this.urlEvents.includes(element2.value)
        ) {
          this.filterSubEvents[element.value][index2].selected = true;
          this.subEvents.push(element2.value);
        } else {
          this.filterSubEvents[element.value][index2].selected = false;
        }
      });
    });

    if (selectedPreset.presetCopy.feed) {
      this.menuFilterNews = new UntypedFormControl(
        selectedPreset.presetCopy.feed.split(','),
      );
    } else {
      this.menuFilterNews = new UntypedFormControl(
        this.filterNews.map((option) => {
          if (option.active) {
            return option.value;
          }
        }),
      );
    }
  }

  /**
   * make single selection work for 'mat-selection-list'
   * @param event
   * @param type
   */
  handleSingleSelection(event, type) {
    if (event.options[0].selected) {
      event.source.deselectAll();
      event.options[0]._setSelected(true);
      if (type === 'timeframe') {
        this.menuFilterTimeframe = new UntypedFormControl(
          event.options[0].value.split(),
        );
        this.markFilterAsCustom();
      } else if (type === 'preset') {
        this.menuFilterTimeframe = new UntypedFormControl(
          event.options[0].value.split(),
        );
        const selectedPreset = this.filterPresets.filter((preset) => {
          return preset.value === event.options[0].value;
        })[0];
        this.handlePresetSelection(selectedPreset);
        if (selectedPreset.presetCopy.time) {
          const dateFrom = DateUtils.fromTo(
            selectedPreset.presetCopy.time,
          ).dateFrom;
          const dateTo = DateUtils.fromTo(
            selectedPreset.presetCopy.time,
          ).dateTo;
          const startDay = this.config.appConfig.setup.startDate;
          const maxDays = INTERNAL_COCKPIT_SETTINGS.maxTimeframe;
          const days = moment(dateTo).diff(moment(dateFrom), 'days');
          if (dateFrom < startDay || dateTo < startDay) {
            alert(
              'Please select another filter, timeframe must be above ' +
                startDay +
                '.',
            );
          }
          if (!this.routing.isDev() && days > maxDays) {
            alert(
              'Please select another filter, the date range cannot exceed ' +
                maxDays +
                ' days.',
            );
          }
        }
      }
    } else {
      if (type === 'preset') {
        event.source.deselectAll();
        event.options[0]._setSelected(true);
      }
    }
  }

  /**
   * handle custom timeframe selection
   * @param value
   */
  handleCustomTimeframeSelection(value) {
    if (value === '0') {
      this.goCustom();
    }
  }

  /**
   * returns matching items
   */
  elementMatches(options, value) {
    const filterValue = value.toLowerCase();
    return options.filter(
      (item) => item.toLowerCase().indexOf(filterValue) === 0,
    );
  }

  /**
   * returns matching group's items
   */
  groupMatches(value) {
    if (value) {
      return this.geographyGroups
        .map((group) => ({
          type: group.type,
          names: this.elementMatches(group.names, value),
        }))
        .filter((group) => group.names.length > 0);
    }
    return this.geographyGroups;
  }

  /**
   * clear all filters if not applied on close
   */
  resetFilterOptions() {
    if (!this.omitReset) {
      this.router.navigate([], {
        queryParams: {
          resetFilters: Math.random(),
        },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      });
    }
    this.omitReset = false;
  }

  /**
   * setup all the filtering options from the main filter menu
   */
  setFilterOptions() {
    this.omitReset = true;

    // Get time and period from timeframe value
    const timeframeValue = this.menuFilterTimeframe.value[0];
    const { time, period } = this.getTimePeriodMapping(timeframeValue);

    // Process all filter values
    const sentiment = this.processSentimentFilter();
    const lang = this.processLanguageFilter();
    const feed = this.processFeedFilter();
    const events = this.processEventsFilter();
    const categories = this.processCategoriesFilter();
    const { continents, countries } = this.processGeographyFilters();
    const factuality = this.processFactualityFilter();
    const temporality = this.processTemporalityFilter();
    const ranks = this.processRanksFilter();
    const panels = this.processPanelsFilter();

    // Update menu button displays
    this.menuButtonLang = this.filterLang.filter(
      (option) => this.menuFilterLang.value.indexOf(option.value) !== -1,
    );
    this.menuButtonNews = this.filterNews.filter(
      (option) => this.menuFilterNews.value.indexOf(option.value) !== -1,
    );

    // Check if event should be unselected
    const checkIfEventUnselected =
      this.params.eventid &&
      this.menuFilterEvents.value.length === 1 &&
      this.menuFilterEvents.value.includes(this.params.eventid)
        ? false
        : true;

    this.router.navigate([], {
      queryParams: {
        time: time,
        period: period,
        filter: sentiment,
        lang: lang,
        feed: feed,
        event_ids: checkIfEventUnselected
          ? events
          : this.params.event_ids
            ? this.params.event_ids
            : null,
        eventid: checkIfEventUnselected
          ? null
          : this.params.eventid
            ? this.params.eventid
            : null,
        eventype: checkIfEventUnselected
          ? null
          : this.params.eventype
            ? this.params.eventype
            : null,
        factuality: factuality,
        temporality: temporality,
        categories: categories,
        continents: continents,
        countries: countries,
        panels: panels,
        ranks: ranks,
        tag: this.tagFilter,
        participant: this.participantFilter,
        newsday: null,
        // score: null
      },
      queryParamsHandling: 'merge' /*, replaceUrl: true*/,
    });
  }

  /**
   * change the language
   */
  inLang(event) {
    if (!event) {
      let lang = this.menuFilterLang.value.join(',');
      if (this.menuFilterLang.value.length === 0) {
        this.menuFilterLang = new UntypedFormControl(
          this.filterLang.map((option) => option.value),
        );
        lang = null;
      }
      this.menuButtonLang = this.filterLang.filter(
        (option) => this.menuFilterLang.value.indexOf(option.value) !== -1,
      );
      this.router.navigate([], {
        queryParams: {
          lang: lang,
          tag: null,
          newsday: null,
        },
        queryParamsHandling: 'merge' /*, replaceUrl: true*/,
      });
    }
  }

  /**
   * parse the feed type
   */
  inNews(event) {
    if (!event) {
      let feed = this.menuFilterNews.value.join(',');
      if (this.menuFilterNews.value.length === 0) {
        feed = null;
        this.menuFilterNews = new UntypedFormControl(
          this.filterNews.map((option) => option.value),
        );
      }
      this.menuButtonNews = this.filterNews.filter(
        (option) => this.menuFilterNews.value.indexOf(option.value) !== -1,
      );
      this.router.navigate([], {
        queryParams: {
          feed: feed,
          tag: null,
        },
        queryParamsHandling: 'merge' /*, replaceUrl: true*/,
      });
    }
  }

  /**
   * save a preset filter
   */
  savePreset() {
    // Get time from timeframe value
    const timeframeValue = this.menuFilterTimeframe.value[0];
    const { time } = this.getTimePeriodMapping(timeframeValue);

    // Process all filter values
    const sentiment = this.processSentimentFilter();
    const lang = this.processLanguageFilter();
    const feed = this.processFeedFilter();
    const events = this.processEventsFilter();
    const categories = this.processCategoriesFilter();
    const { continents, countries } = this.processGeographyFilters();
    const factuality = this.processFactualityFilter();
    const temporality = this.processTemporalityFilter();
    const ranks = this.processRanksFilter();
    const panels = this.processPanelsFilter();

    // Update menu button displays
    this.menuButtonLang = this.filterLang.filter(
      (option) => this.menuFilterLang.value.indexOf(option.value) !== -1,
    );
    this.menuButtonNews = this.filterNews.filter(
      (option) => this.menuFilterNews.value.indexOf(option.value) !== -1,
    );

    const forbiddenNames = [
      'Default',
      '_default_',
      'E events',
      'S events',
      'G events',
    ];
    const existingNames = this.filterPresets.map((preset) => {
      return preset.label;
    });

    const name = prompt('Name of the filter:', '');
    if (
      name &&
      name !== '' &&
      !forbiddenNames.includes(name) &&
      !existingNames.includes(name)
    ) {
      const filter = {
        name: name,
        time: time,
        filter: sentiment,
        lang: lang,
        feed: feed,
        event_ids: events,
        factuality: factuality,
        temporality: temporality,
        categories: categories,
        continents: continents,
        countries: countries,
        panels: panels,
        ranks: ranks,
      };
      this.filterPresets.splice(1, 0, {
        value: name,
        label: name,
        visible: false,
        presetCopy: filter,
      });
      this.filterApi.setFilter(filter).subscribe(() => {
        this.presetsSelectionList.deselectAll();
        // @ts-expect-error Description: This error is expected because the following code is accessing a private property.
        this.presetsSelectionList.options._results[1]._setSelected(true);
      });
    } else if (forbiddenNames.includes(name)) {
      alert(
        'Provided name is reserved for special filter presets. Please choose a different name.',
      );
    } else if (existingNames.includes(name)) {
      alert(
        'Provided name belongs to one of the existing filter presets. Please choose a different name.',
      );
    }
  }

  /**
   * delete a preset filter
   */
  delPreset(filter) {
    if (window.confirm('Delete ' + filter.value + ' filter?')) {
      this.filterPresets = this.filterPresets.filter((item) => {
        return item.value !== filter.value;
      });
      if (
        this.menuFilterPresets.value &&
        this.menuFilterPresets.value.includes(filter.value)
      ) {
        this.menuFilterPresets = new UntypedFormControl();
      }
      this.filterApi.getFilter().subscribe((result) => {
        const filterId = result.filter((item) => {
          return item.name === filter.value;
        })[0].id;
        this.filterApi.delFilter(filterId).subscribe();
      });
    }
  }

  /**
   * reorder filter presets to put custom default or Default at the top
   */
  reorderFilterPresets() {
    if (this.nameCustomDefault) {
      // Move custom default filter to the very top of the list
      const customDefaultIndex = this.filterPresets.findIndex(
        (preset) => preset.label === this.nameCustomDefault,
      );
      if (customDefaultIndex > 0) {
        const customDefaultPreset = this.filterPresets.splice(
          customDefaultIndex,
          1,
        )[0];
        this.filterPresets.unshift(customDefaultPreset);
      }
    } else {
      // Move Default preset back to the top
      const defaultIndex = this.filterPresets.findIndex(
        (preset) => preset.label === 'Default',
      );
      if (defaultIndex > 0) {
        const defaultPreset = this.filterPresets.splice(defaultIndex, 1)[0];
        this.filterPresets.unshift(defaultPreset);
      }
    }
  }

  /**
   * set chosen preset as a default filter
   */
  setDefaultPreset(filter) {
    if (window.confirm('Set ' + filter.value + ' as a default filter?')) {
      const defaultFilter = {};
      Object.assign(
        defaultFilter,
        {
          time: filter.presetCopy.time,
          feed: filter.presetCopy.feed,
          filter: filter.presetCopy.filter,
          lang: filter.presetCopy.lang,
          ranks: filter.presetCopy.ranks,
          panels: filter.presetCopy.panels,
          categories: filter.presetCopy.categories,
          continents: filter.presetCopy.continents,
          countries: filter.presetCopy.countries,
          factuality: filter.presetCopy.factuality,
          temporality: filter.presetCopy.temporality,
          event_ids: filter.presetCopy.event_ids,
        },
        {
          name: '_default_',
          defaultFilter: filter.label,
        },
      );
      if (this.idCustomDefault !== undefined) {
        this.filterApi.delFilter(this.idCustomDefault).subscribe(() => {
          this.filterApi.setFilter(defaultFilter).subscribe((result) => {
            Object.assign(this.presetCustomDefault, defaultFilter);
            this.idCustomDefault = result.id;
            this.nameCustomDefault = filter.label;
            this.userState.filter = filter.label;
            this.reorderFilterPresets();
            this.presetsSelectionList.deselectAll();
            // Find and select the custom default filter
            // @ts-expect-error Accessing private _results property
            const results = this.presetsSelectionList.options._results;
            const customDefaultOption = results.find(
              (option: any) => option._value === filter.label,
            );
            if (customDefaultOption) {
              customDefaultOption._setSelected(true);
            }
            this.handlePresetSelection({
              value: filter.value,
              label: filter.label,
              visible: false,
              presetCopy: filter.presetCopy,
            });
          });
        });
      } else {
        this.filterApi.setFilter(defaultFilter).subscribe((result) => {
          Object.assign(this.presetCustomDefault, defaultFilter);
          this.idCustomDefault = result.id;
          this.nameCustomDefault = filter.label;
          this.userState.filter = filter.label;
          this.reorderFilterPresets();
          this.presetsSelectionList.deselectAll();
          // Find and select the custom default filter
          // @ts-expect-error Accessing private _results property
          const results = this.presetsSelectionList.options._results;
          const customDefaultOption = results.find(
            (option: any) => option._value === filter.label,
          );
          if (customDefaultOption) {
            customDefaultOption._setSelected(true);
          }
          this.handlePresetSelection({
            value: filter.value,
            label: filter.label,
            visible: false,
            presetCopy: filter.presetCopy,
          });
        });
      }
    }
  }

  /**
   * reset default filter back to the original Default preset
   */
  resetDefaultPreset() {
    if (window.confirm('Reset default filter?')) {
      if (this.idCustomDefault !== undefined) {
        this.filterApi.delFilter(this.idCustomDefault).subscribe();
        Object.assign(this.presetCustomDefault, this.presetDefault);
        this.idCustomDefault = undefined;
        this.nameCustomDefault = undefined;
        this.userState.filter = 'Default';
        this.reorderFilterPresets();
        this.presetsSelectionList.deselectAll();
        // Find and select the Default preset
        // @ts-expect-error Accessing private _results property
        const results = this.presetsSelectionList.options._results;
        const defaultOption = results.find(
          (option: any) => option._value === 'Default',
        );
        if (defaultOption) {
          defaultOption._setSelected(true);
        }
        this.handlePresetSelection({
          value: 'Default',
          label: 'Default',
          visible: false,
          presetCopy: this.presetDefault,
        });
      }
    }
  }

  /**
   * make filter-actions visible on mouseenter
   */
  onMouseEnter(preset) {
    preset.visible = true;
  }

  /**
   * make filter-actions not visible on mouseleave
   */
  onMouseLeave(preset) {
    preset.visible = false;
  }
  /**
   * open help component
   */
  openHelp() {
    this.dialog.open(HelpComponent, {
      data: { component: 'filter' },
    });
  }

  // ===== HELPER METHODS =====

  /**
   * Get time and period mapping based on timeframe value
   */
  private getTimePeriodMapping(timeframeValue: string): {
    time: string;
    period: string;
  } {
    const time = timeframeValue === '0' ? this.time : timeframeValue;
    const period = TIMEFRAME_PERIOD_MAP[timeframeValue]?.period || this.period;
    return { time, period };
  }

  /**
   * Mark the current filter as custom
   */
  private markFilterAsCustom(): void {
    this.presetsSelectionList.deselectAll();
    this.userState.filter = PRESET_NAMES.CUSTOM;
  }

  /**
   * Process sentiment filter values
   */
  private processSentimentFilter(): string | null {
    let sentiment = this.menuFilterSentiment.value.join(',');
    if (this.menuFilterSentiment.value.length === this.filterSentiment.length) {
      sentiment = null;
    }
    if (this.menuFilterSentiment.value.length === 0) {
      this.menuFilterSentiment = new UntypedFormControl(
        this.filterSentiment.map((option) => option.value),
      );
      sentiment = null;
    }
    return sentiment;
  }

  /**
   * Process language filter values
   */
  private processLanguageFilter(): string | null {
    let lang = this.menuFilterLang.value.join(',');
    if (this.menuFilterLang.value.length === this.filterLang.length) {
      lang = null;
    }
    if (this.menuFilterLang.value.length === 0) {
      this.menuFilterLang = new UntypedFormControl(
        this.filterLang.map((option) => option.value),
      );
      lang = null;
    }
    return lang;
  }

  /**
   * Process feed filter values
   */
  private processFeedFilter(): string | null {
    let feed = this.menuFilterNews.value.join(',');
    if (this.menuFilterNews.value.length === this.filterNews.length) {
      feed = null;
    }
    if (this.menuFilterNews.value.length === 0) {
      this.menuFilterNews = new UntypedFormControl(
        this.filterNews.map((option) => option.value),
      );
      feed = null;
    }
    return feed;
  }

  /**
   * Process events filter - returns selected event IDs
   */
  private processEventsFilter(): string | null {
    if (
      !this.menuFilterEvents.value ||
      this.menuFilterEvents.value.length === 0
    ) {
      return null;
    }
    return this.menuFilterEvents.value.join(',');
  }

  /**
   * Process categories filter - returns UNSELECTED categories for API
   */
  private processCategoriesFilter(): string | null {
    if (!this.menuFilterCategories.value) {
      return null;
    }
    // Return unselected categories
    const unselected = this.filterCategories
      .filter(
        (option) => !this.menuFilterCategories.value.includes(option.value),
      )
      .map((option) => option.value)
      .join(',');
    return unselected || null;
  }

  /**
   * Process geography filters (continents and countries)
   */
  private processGeographyFilters(): {
    continents: string | null;
    countries: string | null;
  } {
    if (
      !this.menuFilterGeography.value ||
      this.menuFilterGeography.value.length === 0
    ) {
      return { continents: null, countries: null };
    }

    const continentValues = new Set(
      this.filterGeography.continents.map((c) => c.value),
    );
    const continentsArray = this.menuFilterGeography.value.filter((item) =>
      continentValues.has(item),
    );

    const countriesSet = new Set(
      this.filterGeography.countries.map((c) => c.value),
    );
    const countriesArray = this.menuFilterGeography.value.filter((item) =>
      countriesSet.has(item),
    );

    const continents =
      continentsArray.length !== 0
        ? continentsArray.map((item) => item.split(' ').pop()).join(',')
        : null;

    const countries =
      countriesArray.length !== 0
        ? countriesArray.map((item) => item.split(' ').pop()).join(',')
        : null;

    return { continents, countries };
  }

  /**
   * Process factuality filter from factTemp combined control
   */
  private processFactualityFilter(): string | null {
    if (
      !this.menuFilterFactTemp.value ||
      this.menuFilterFactTemp.value.length === 0
    ) {
      return null;
    }
    const factualitySet = new Set(
      this.filterFactTemp.factuality.map((f) => f.value),
    );
    const factualityArray = this.menuFilterFactTemp.value.filter((item) =>
      factualitySet.has(item),
    );
    return factualityArray.length !== 0
      ? factualityArray.map((item) => item.split(' ').pop()).join(',')
      : null;
  }

  /**
   * Process temporality filter from factTemp combined control
   */
  private processTemporalityFilter(): string | null {
    if (
      !this.menuFilterFactTemp.value ||
      this.menuFilterFactTemp.value.length === 0
    ) {
      return null;
    }
    const temporalitySet = new Set(
      this.filterFactTemp.temporality.map((t) => t.value),
    );
    const temporalityArray = this.menuFilterFactTemp.value.filter((item) =>
      temporalitySet.has(item),
    );
    return temporalityArray.length !== 0
      ? temporalityArray.map((item) => item.split(' ').pop()).join(',')
      : null;
  }

  /**
   * Process ranks filter
   */
  private processRanksFilter(): string | null {
    if (
      !this.menuFilterRanks.value ||
      this.menuFilterRanks.value.length === 0
    ) {
      return null;
    }
    return this.menuFilterRanks.value.join(',');
  }

  /**
   * Process panels filter
   */
  private processPanelsFilter(): string | null {
    if (
      !this.menuFilterPanels.value ||
      this.menuFilterPanels.value.length === 0
    ) {
      return null;
    }
    return this.menuFilterPanels.value.join(',');
  }

  /**
   * Process all filters and return their values
   */
  private processAllFilters(): {
    sentiment: string | null;
    lang: string | null;
    feed: string | null;
    events: string | null;
    categories: string | null;
    continents: string | null;
    countries: string | null;
    factuality: string | null;
    temporality: string | null;
    ranks: string | null;
    panels: string | null;
  } {
    const sentiment = this.processSentimentFilter();
    const lang = this.processLanguageFilter();
    const feed = this.processFeedFilter();
    const events = this.processEventsFilter();
    const categories = this.processCategoriesFilter();
    const { continents, countries } = this.processGeographyFilters();
    const factuality = this.processFactualityFilter();
    const temporality = this.processTemporalityFilter();
    const ranks = this.processRanksFilter();
    const panels = this.processPanelsFilter();

    return {
      sentiment,
      lang,
      feed,
      events,
      categories,
      continents,
      countries,
      factuality,
      temporality,
      ranks,
      panels,
    };
  }

  /**
   * Update a filter control with new values
   */
  private updateFilterControl(
    filterControl: UntypedFormControl,
    newValue: any[],
  ): void {
    filterControl.setValue(newValue);
    this.markFilterAsCustom();
  }

  /**
   * Check if all events are selected
   */
  get areAllEventsSelected(): boolean {
    return (
      this.menuFilterEvents?.value?.length > 0 &&
      this.allSubEvents?.length > 0 &&
      this.menuFilterEvents.value.length === this.allSubEvents.length
    );
  }

  /**
   * Check if all categories are selected
   */
  get areAllCategoriesSelected(): boolean {
    return (
      this.menuFilterCategories?.value?.length > 0 &&
      this.filterCategories?.length > 0 &&
      this.menuFilterCategories.value.length === this.filterCategories.length
    );
  }

  /**
   * Update selection flags for filter arrays
   */
  private updateSelectionFlags<T extends { selected: boolean; value: string }>(
    array: T[],
    formControlValue: string[],
    disabledList: string[] = [],
  ): void {
    array.forEach((element) => {
      if (formControlValue !== null) {
        element.selected = formControlValue.includes(element.value);
      } else {
        element.selected = !disabledList.includes(element.value);
      }
    });
  }

  /**
   * Check if timeframe has changed
   */
  private hasTimeChanged(params: any, preset: any): boolean {
    return (
      (params.time && params.time !== preset.time) ||
      (!params.time && '7' !== preset.time && null !== preset.time)
    );
  }

  /**
   * Check if feed has changed
   */
  private hasFeedChanged(params: any, preset: any): boolean {
    return (
      (params.feed && params.feed !== preset.feed) ||
      (!params.feed &&
        'non_professional,online,print,professional' !== preset.feed &&
        null !== preset.feed)
    );
  }

  /**
   * Check if sentiment has changed
   */
  private hasSentimentChanged(params: any, preset: any): boolean {
    return (
      (params.filter && params.filter !== preset.sentiment) ||
      (!params.filter &&
        'pos,neu,neg' !== preset.sentiment &&
        null !== preset.sentiment)
    );
  }

  /**
   * Check if language has changed
   */
  private hasLanguageChanged(params: any, preset: any): boolean {
    return (
      (params.lang && params.lang !== preset.lang) ||
      (!params.lang && 'en,de' !== preset.lang && null !== preset.lang)
    );
  }

  /**
   * Check if ranks have changed
   */
  private hasRanksChanged(params: any, preset: any): boolean {
    return (
      (params.ranks && params.ranks !== preset.ranks) ||
      (!params.ranks && null !== preset.ranks)
    );
  }

  /**
   * Check if panels have changed
   */
  private hasPanelsChanged(params: any, preset: any): boolean {
    return (
      (params.panels && params.panels !== preset.panels) ||
      (!params.panels && null !== preset.panels)
    );
  }

  /**
   * Check if categories have changed
   */
  private hasCategoriesChanged(params: any, preset: any): boolean {
    return (
      (params.categories && params.categories !== preset.categories) ||
      (!params.categories && null !== preset.categories)
    );
  }

  /**
   * Check if events have changed
   */
  private hasEventsChanged(params: any, preset: any): boolean {
    return (
      (params.events && params.events !== preset.events) ||
      (!params.events && null !== preset.events)
    );
  }

  /**
   * Check if continents have changed
   */
  private hasContinentsChanged(params: any, preset: any): boolean {
    return (
      (params.continents && params.continents !== preset.continents) ||
      (!params.continents && null !== preset.continents)
    );
  }

  /**
   * Check if countries have changed
   */
  private hasCountriesChanged(params: any, preset: any): boolean {
    return (
      (params.countries && params.countries !== preset.countries) ||
      (!params.countries && null !== preset.countries)
    );
  }

  /**
   * Check if factuality has changed
   */
  private hasFactualityChanged(params: any, preset: any): boolean {
    return (
      (params.factuality && params.factuality !== preset.factuality) ||
      (!params.factuality && null !== preset.factuality)
    );
  }

  /**
   * Check if temporality has changed
   */
  private hasTemporalityChanged(params: any, preset: any): boolean {
    return (
      (params.temporality && params.temporality !== preset.temporality) ||
      (!params.temporality && null !== preset.temporality)
    );
  }

  /**
   * Check if any filter params have changed from preset
   */
  private hasFilterChanged(params: any, preset: any): boolean {
    return (
      this.hasTimeChanged(params, preset) ||
      this.hasFeedChanged(params, preset) ||
      this.hasSentimentChanged(params, preset) ||
      this.hasLanguageChanged(params, preset) ||
      this.hasRanksChanged(params, preset) ||
      this.hasPanelsChanged(params, preset) ||
      this.hasCategoriesChanged(params, preset) ||
      this.hasEventsChanged(params, preset) ||
      this.hasContinentsChanged(params, preset) ||
      this.hasCountriesChanged(params, preset) ||
      this.hasFactualityChanged(params, preset) ||
      this.hasTemporalityChanged(params, preset)
    );
  }

  /**
   * Toggle all items in a list
   */
  private toggleAllItems<T extends { selected: boolean; value: string }>(
    items: T[],
    formControl: UntypedFormControl,
  ): void {
    const allValues = items.map((item) => item.value);
    const shouldSelectAll = formControl.value?.length !== allValues.length;

    items.forEach((item) => {
      item.selected = shouldSelectAll;
    });
    formControl.setValue(shouldSelectAll ? allValues : []);
    this.markFilterAsCustom();
  }
}
